import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';

interface ColumnHeaderWithTooltipProps {
  label: React.ReactNode;
  tooltip?: React.ReactNode;
  id?: string;
}

export const ColumnHeaderWithTooltip: React.FC<ColumnHeaderWithTooltipProps> = ({ label, tooltip, id }) => (
  <Box id={id} display="flex" alignItems="center" gap={0.5}>
    <Typography variant="subtitle2">{label}</Typography>
    {tooltip && (
      <Tooltip title={tooltip}>
        <InfoOutlined
          fontSize="extraSmall"
          sx={(theme) => ({ color: theme.palette.text.secondary, cursor: 'pointer' })}
        />
      </Tooltip>
    )}
  </Box>
);
